/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { BuilderUserContext } from '@gh/builder-shared';

import { htmlCellRenderer } from '@gh/common-internal-shared';
import { TypeService } from '@gh/core-type';
import { LayoutBasedGridDefinition } from '@gh/core-ui-grid';

import { GridOptions, ICellRendererParams } from 'ag-grid-community';
import { replace } from 'lodash';

@Injectable()
export class TodoPassedGridDefinition extends LayoutBasedGridDefinition {

  columnDefs = {
    dueDate: {
      valueFormatter: (params: any) => this.typeService.get('DayMonth').format(params.value),
    },
    message: {
      cellRenderer: (params: ICellRendererParams) => {
        const baseUrl = (this.userContext.baseUrl || '').replace(/\/+$/, '');
        const value = replace(
          replace(params.value, '%BASE_URL%', baseUrl), '<a ', '<a target="_blank" ');
        return htmlCellRenderer({ ...params, value });
      },
    },
  };

  constructor(private typeService: TypeService,
              private userContext: BuilderUserContext) {
    super();
  }

  buildGridOptions(): GridOptions {
    return { getRowId: (params) => String(params.data.id)};
  }
}
